import { useEffect, useState } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import BuyInvoicePaymentForm from "@components/forms/BuyInvoicePaymentForm";
import { BuyInvoiceApi, BuyInvoiceDataType } from "@/api/BuyInvoiceApi";
import { BuyInvoiceFormDataKeys } from "@/generated/BuyInvoiceFormDataKeys";
import { buyInvoiceRelatedAttributes } from "@/formTypes/BuyInvoiceDataType";

const BuyInvoicePaymentAddEdit = () => {
  const params = useParams()
  const { id: buyInvoicePaymentId, buyInvoiceId } = params; ``
  const [buyInvoice, setBuyInvoice] = useState<BuyInvoiceDataType>({})

  useEffect(() => {
    if (buyInvoiceId) {
      const run = async (buyInvoiceId: string) => {
        const invoices = await BuyInvoiceApi.get(buyInvoiceId, {
          selectionSet: [
            ...BuyInvoiceFormDataKeys.filter(k => !buyInvoiceRelatedAttributes.includes(k)),
            "currency.*"
          ]
        });
        setBuyInvoice(invoices);
      }
      run(buyInvoiceId);
    }
  }, [buyInvoiceId]);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!buyInvoicePaymentId ? 'Agregar' : 'Editar'} Abono de Factura electronica de Compra`}
      backUrl={`/user/buyInvoices/payments/${buyInvoiceId}`}
      primaryActions={
        [
          {
            actionTitle: "Guardar",
            formId: "buyInvoicePaymentForm",
            type: "submit",
            color: "success"
          }
        ]}
    >
      {buyInvoice?.id && (
        <BuyInvoicePaymentForm
          formId="buyInvoicePaymentForm"
          id={buyInvoicePaymentId}
          buyInvoice={buyInvoice}
          saveRedirectUrl={`/user/buyInvoices/payments/${buyInvoiceId}`}
        ></BuyInvoicePaymentForm>
      )}

    </PageContainer >
  );
}

export default BuyInvoicePaymentAddEdit;
